import { get } from 'lodash';

import { localStorage } from '@shared/utils';

import Api from '@/data';
import { Toast } from '@/widgets';
import { textConstant } from '@/constants';

import constants from './constants';

const { SOMETHING_WENT_WRONG } = textConstant;

class TestModeService {
	private static testModeToken: string;
	static {
		this.testModeToken =
			localStorage.getItem(constants.TEST_MODE_AUTH_KEY) || '';
	}

	private static async initSimulatorLogin() {
		try {
			const authResponse = await Api.getSimulatorAuth();
			if (authResponse?.data?.authToken) {
				const loginRes = await Api.simulatorLogin({
					accessToken: authResponse.data.authToken,
				});
				return loginRes.data?.token;
			} else {
				return null;
			}
		} catch (error) {
			Toast.error(get(error, 'data.message', SOMETHING_WENT_WRONG));
		}
	}

	static async setTestMode(status: boolean): Promise<boolean> {
		if (!status) {
			localStorage.removeItem(constants.TEST_MODE_AUTH_KEY);
			this.testModeToken = '';
			return false;
		}

		const auth = await this.initSimulatorLogin();
		if (!auth) return false;

		localStorage.setItem(constants.TEST_MODE_AUTH_KEY, auth);
		this.testModeToken = auth;
		return true;
	}

	static getTestModeToken() {
		return this.testModeToken;
	}

	static isTestModeEnabled() {
		return Boolean(this.testModeToken);
	}
}

export default TestModeService;
